import { useEffect, useState } from "react";
import { NeedHelp, SearchIcon } from "../../../atoms/CustomIcons";
import Header from "../../../atoms/Header";
import DashboardTemplate from "../../../templates/Dashboard";
import EditableTable from "./Components/EditableTable";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import { getTakeoffById, removeTakeoffListingData } from "./ducks/actions";
import { Input } from "antd";
import { takeOffTableType } from "./ducks/types";

export default function TakeoffMeasurements() {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("");
  const [data, setData] = useState<takeOffTableType[]>([]);
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const takeOffListing = useAppSelector((state) => state?.takeOff?.takeOffData);

  useEffect(() => {
    if (companyId) {
      dispatch(getTakeoffById(companyId));
    }
  }, [companyId, dispatch]);

  useEffect(() => {
    dispatch(removeTakeoffListingData());
  }, [dispatch]);

  useEffect(() => {
    const currentData = takeOffListing?.data;
    let filteredData: takeOffTableType[] = [];

    if (value && currentData) {
      filteredData = currentData?.filter((entry) => {
        const typedData = value
          ? entry?.name && entry?.name.toLowerCase().includes(value)
          : true;

        return typedData;
      });
      setData(filteredData);
    } else {
      setData(takeOffListing?.data ?? []);
    }
  }, [value, takeOffListing]);

  return (
    <DashboardTemplate loading={takeOffListing?.loader || loading}>
      <Header
        breadcrumb={[
          { label: "Company settings", href: `/company-settings/${companyId}` },
          { label: "Takeoff measurements" },
        ]}
        title="Takeoff measurements"
        description="Edit the list of takeoff measurements for estimates."
        btnText1="Need help?"
        btnIcon1={<NeedHelp />}
      />

      <div className="maxWidth" style={{ maxWidth: "1200px" }}>
        <div className="search_box">
          <Input
            placeholder="Search takeoff measurements"
            value={value}
            onChange={(e) => setValue(e?.target?.value?.toLowerCase())}
            prefix={<SearchIcon />}
            allowClear
          />
        </div>
        <div className="tableScroll">
          <EditableTable
            data={data}
            setLoading={setLoading}
            loading={loading}
          />
        </div>
      </div>
    </DashboardTemplate>
  );
}
